<!-- Announcements -->
@if (criticalAnnouncements$ | async; as criticalAnnouncements) {
    @if (criticalAnnouncements.length) {
        @for (announcement of criticalAnnouncements; track announcement.id) {
            <app-announcement [announcement]="announcement" (onDismiss)="dismiss(announcement)"></app-announcement>
        }
    }
}
